import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-znmj",
  "use": "icon-znmj-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-znmj\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 0v1024h832V0H64z m768 960H128V64h704v896zM768 128H192v768h576V128z m-64 704H256V192h448v640z m-64-320H576V384h64v128z\" fill=\"\" p-id=\"51168\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol